import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';

import { CastMember } from '../../classes/cast-member';
import { StorageService } from '../../services/storage/storage.service';

@Injectable()
export class UserAccessService {
    constructor(
        private storageService: StorageService,
    ) { }

    private user: CastMember;

    public hasRole(role: string) {
        /* istanbul ignore next */
        this.user = this.storageService.getSession('user') || {};

        return _.includes(this.user.roles, role);
    }

    public hasAccess(...functionalAbilities: any[]) {
        /* istanbul ignore next */
        this.user = this.storageService.getSession('user') || {};

        return functionalAbilities.every(andFA => {
            /* istanbul ignore else */
            if (!Array.isArray(andFA)) { andFA = [andFA]; }

            return andFA;
        });
    }

    public getUser() {
        return this.storageService.getSession('user');
    }

    public setUser(user) {
        return this.storageService.setSession('user', user);
    }

    public setLanguage(language) {
        return this.storageService.setSession('language', language);
    }
}
